export default __webpack_public_path__ + "static/media/ps_powerbutton_icon.1e036b3a.svg";